import { useState, useRef, useEffect } from 'react';
import {Modal, Button, Form, Col, Row, Container } from 'react-bootstrap';
import { useSelector } from "react-redux";
import '../../assets/Styles/NoShowTripCSS/NoShowTripCSS.css';
import APICom from '../../utils/helpers/APICom';
import PersistStorage from '../../utils/helpers/PersistStorage';

const NoShow = (props) => {

    const noshowReasonRef = useRef();
    const noshowCommentRef = useRef();
    const noshowInternalCommentRef = useRef();
    const chkReturnTripRef = useRef();

      /////////////////////////////////////////////////////  NOSHOW COMPONENT HOOKS ///////////////////////////////////////////////////////
    const [affSelected, setAffSelected] = useState(-1);
    const [isComponentLoading, setIsComponentLoading] = useState(true);

    const [NoShowlDialog, setNoShowDialog] = useState(false);
    const [noShowReasons, setNoShowReasons] = useState([]);

    const [noShowObj, setNoShowObj] = useState({ iRefID: '', iATSPID:'', ServiceID:'',TripRequestStatus:'', iAssignedVehicleId:'', AssignedDriverId:'',
    PZONE:'', iUserID:'-1',IsReturnTrip:'false', iNoShowReasonID:'-1', vOtherNoShowComments:'', InternalNotes:'', DisplayName:'', CreatedBy: '', AffiliateName: ''});
    
    const [displayNoShowAlert, setDisplayNoShowAlert] = useState(false);
    const [noShowAlert, setNoShowAlert] = useState({alertTitle: '', alertMsg:''});
    
    const [showTripStatus, setShowTripStatus] = useState(false);
    const [IsReturnTrip, setIsReturnTrip] = useState("false");
    const [isReturnTripCheckBox, setIsReturnTripChecBox] = useState(false);
    const [chkReturnTripVisible, setchkReturnTripVisible] = useState(false);
    const[WMRUrl, setWMRUrl] = useState('');
    // Per Affiliate Setting do not exsist
    // const[bShowFavorDialog, setbShowFavorDialog] = useState('');
    // const[firstinzoneifnsp, setfirstinzoneifnsp] = useState('');
    // const[firstinzoneifcan, setfirstinzoneifcan] = useState('');
    // const[CheckInOnStand, setCheckInOnStand] = useState('');


    // Fetching NoShow Reason for Dropdown
    const { NoShowReasonData, ASCSSettingData, AffiliateData } = useSelector((store) => store.combinedata);
    const { loginData }  = useSelector((store) => store.login);

    const [showConfirmationPromptForReturnCanNS, setShowConfirmationPromptForReturnCanNS] = useState(false);
    const [confirmationPromptForReturnCanNSAlert, setConfirmationPromptForReturnCanNSAlert] = useState({alertTitle: '', alertMsg:''});
    const isReturnCanNSRef = useRef(false);
  
    const [promptForReturnCanNS, setPromptForReturnCanNS] = useState(true);

    useEffect(() => {
        if(ASCSSettingData !== null && ASCSSettingData !== undefined)
        {
          let iAffiliateID = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
          if(iAffiliateID !== undefined && iAffiliateID !== ""){
            iAffiliateID = parseInt(iAffiliateID);
            setAffSelected(iAffiliateID);
          }
            if (ASCSSettingData.hasOwnProperty(iAffiliateID)) {
              const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[iAffiliateID]); // Parse JSON string into an array
              for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
              {
                    if(ascsSettingDataByAffiliate[i]["SubTitle"] === "PromptForReturnCanNS")
                    {
                      setPromptForReturnCanNS(
                        String(ascsSettingDataByAffiliate[i]["value"]).toLowerCase() === "true"
                      );
                      break;
                    }
              }
            }
        }
      }, [ASCSSettingData]);


    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setNoShowAlert({...noShowAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to perform no show.'});
            setDisplayNoShowAlert(true);
        }
        else if(props.GridRowData.length > 1)
        {
            setNoShowAlert({...noShowAlert, alertTitle: 'Multiple trips selected', alertMsg:'Please select one trip to perform no-show.'});
            setDisplayNoShowAlert(true);
        }
        else
        {
            const gData = props.GridRowData[0];
            setNoShowObj((prevnoShowObj) => ({...prevnoShowObj, iRefID: gData.ConfirmationNo, iATSPID:gData.iSRATSPID, ServiceID:gData.ServiceID,
            TripRequestStatus:gData.TripRequestStatus, 
            iAssignedVehicleId:(gData.iAssignedVehicleId === undefined || gData.iAssignedVehicleId === null || gData.iAssignedVehicleId === "")? '-1': gData.iAssignedVehicleId, 
            AssignedDriverId:(gData.AssignedDriverId === undefined || gData.AssignedDriverId === null || gData.AssignedDriverId === "")?'-1':  gData.AssignedDriverId,
            PZONE:gData.PZONE, DisplayName:gData.PickupPerson, CreatedBy: gData.CreatedBy, AffiliateName: gData.Affiliate}));

            setIsReturnTrip(((gData.IsReturnTrip === "")?"false":gData.IsReturnTrip));
            //setIsReturnTrip((gData.IsReturnTrip ?? "") === "" ? false : true);
            if(ASCSSettingData !== null && ASCSSettingData !== undefined)
                {
                    if (ASCSSettingData.hasOwnProperty(gData.iSRATSPID)) {
                      const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[gData.iSRATSPID]); // Parse JSON string into an array
                      for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                      {
                            if(ascsSettingDataByAffiliate[i]["SubTitle"] === "WMRAPIURL")
                            {
                                setWMRUrl(ascsSettingDataByAffiliate[i]["value"]);
                            }
                      }
                    }
                }
        }
    }, []);


    useEffect(() => {
        if(isComponentLoading)
        {
          setIsComponentLoading(false);
          return;
        }
    
        NoShowTripFromARQPRQSRQ();
    
      }, [IsReturnTrip]);


      const waitForUserConfirmation = (alertMsgText) => {
        return new Promise((resolve) => {
          setConfirmationPromptForReturnCanNSAlert({
            alertMsg: alertMsgText,
            onConfirm: () => {
               
              isReturnCanNSRef.current = true;
              setShowConfirmationPromptForReturnCanNS(false);
              resolve(true);
            },
            onCancel: () =>{
               
              isReturnCanNSRef.current = false;
              setShowConfirmationPromptForReturnCanNS(false);
              resolve(true);
            },
            onOk: () =>{
               
              isReturnCanNSRef.current = false;
              setShowConfirmationPromptForReturnCanNS(false);
              resolve(true);
            } 
          });
          setShowConfirmationPromptForReturnCanNS(true);
        });
      };
      

    const NoShowTripFromARQPRQSRQ = () => 
    {
        let CreatedBy = noShowObj.CreatedBy;
        let HasAffiliateInThirdParty = CheckIfTripIsBrokerTrip(noShowObj.iATSPID);
        if (CreatedBy !== "(ExternalDispatch)" && HasAffiliateInThirdParty === true) {
            setNoShowAlert({...noShowAlert, alertTitle: 'No Show Restriction', alertMsg:`The trip is assigned to an Affiliate (${noShowObj.AffiliateName}) and only Affiliate can initiate a No-Show Action.`});
            setDisplayNoShowAlert(true);
            return false;
          }
      
          if (noShowObj.TripRequestStatus.toLocaleLowerCase() === "pickedup") {
            setShowTripStatus(true);
          }
          if(IsReturnTrip?.toLocaleLowerCase() === "true")
          {
              setchkReturnTripVisible(true);
              setIsReturnTripChecBox(false);
          }else
          {
            setchkReturnTripVisible(false);
            setIsReturnTripChecBox(false);
          }
      
          setNoShowDialog(true);
    }

    const CheckIfTripIsBrokerTrip = (iSRATSPID) => {
        let bQualifyAsBrokerTrip = false;
        try {
            for (var i = 0; i < AffiliateData.length; i++) {
                if (AffiliateData[i].AffiliateID.toString() === iSRATSPID.toString()
                    && AffiliateData[i].bBroker.toString().toLowerCase() === "1"
                    && AffiliateData[i].bExternalBroker.toString().toLowerCase() === "false"
                ) {
                    bQualifyAsBrokerTrip = true;
                    break;
                }
            }
        }
        catch (dsf) { return false; }
        return bQualifyAsBrokerTrip;
    }

    const LoadingNoShowReasonByAffiliate = () => {
        //const NoShowReasonJSON = (NoShowReasonData[props.GridRowData[0].iSRATSPID] !== undefined)? JSON.parse(NoShowReasonData[props.GridRowData[0].iSRATSPID]): undefined;
        const NoShowData = NoShowReasonData[props.GridRowData[0].iSRATSPID];
        const NoShowReasonJSON = (NoShowData !== undefined && NoShowData !== null && NoShowData !== "") ? JSON.parse(NoShowData) : undefined;
        if(NoShowReasonJSON){
          const noshowReasonByAffiliate = [];
          noshowReasonByAffiliate.push({"name": "Select reason ...", "id": -1, "description": "" });
          NoShowReasonJSON.map((item) => {
            return noshowReasonByAffiliate.push({"name": item.vTitle, "id": item.iId, "description": item.vDescription });
          })
          if(noshowReasonByAffiliate.length > 0)
          {
            setNoShowReasons(noshowReasonByAffiliate);
          }
        }else{
          setNoShowAlert({...noShowAlert, alertTitle: 'NoShow Reasons', alertMsg:'Error loading noshow reasons!'});
          setDisplayNoShowAlert(true);
          return false;
        }
    }

    const OpenNoShowDialg = ()=> { 
        LoadingNoShowReasonByAffiliate();
      }


    const handleReturnTripCheckBox = () => {
        setIsReturnTripChecBox(prevValue => !prevValue);
    }

    const handleCancelReasonChange = (e) => {
        const iTem = noShowReasons.find((item) => {
            return (item.id === Number(e.target.value)) 
          })
          if(iTem)
            noshowCommentRef.current.value = iTem.description;
    }

    const handleNoShowDialogOK = async() => {

        if(Number(noshowReasonRef.current.value) <= 0)
        {
            setNoShowAlert({...noShowAlert, alertTitle: 'No-Show Reason', alertMsg:'Please select no-show reason!'});
            setDisplayNoShowAlert(true);
            return false;
        }
        else
        {
            noShowObj["IsReturnTrip"] = (chkReturnTripRef.current === undefined) ? false: chkReturnTripRef.current.checked;
            noShowObj["iNoShowReasonID"] = noshowReasonRef.current.value;
            noShowObj["vOtherNoShowComments"] = noshowCommentRef.current.value;
            noShowObj["InternalNotes"] = noshowInternalCommentRef.current.value;
            noShowObj["iUserID"] = loginData.iUserID;
            noShowObj["WMRUrl"] = ''
            noShowObj["iAppID"] = '26'

            //Confirmation Section for Return Trip Cancellation
            //----------------------------------------------------------------
            if(String(IsReturnTrip)?.toLowerCase() === "true")
            {
                if(promptForReturnCanNS){
                    const userConfirmed = await waitForUserConfirmation("Do you want to cancel the return trip");
        
                    if (!userConfirmed) return;
                    
                    if(isReturnCanNSRef.current === true){
                        noShowObj["IsReturnTrip"] = true;
                    }
                    else if(isReturnCanNSRef.current === false){
                        noShowObj["IsReturnTrip"] = false;
                    }
                }
                else{
                    if(IsReturnTrip?.toLocaleLowerCase() === "true"){
                        const userConfirmed = await waitForUserConfirmation("There is a return trip of this rider, Please take care of that manually.");
            
                        if (!userConfirmed) return;
                        noShowObj["IsReturnTrip"] = false;
                    }
                }
            }
            //----------------------------------------------------------------
            //Confirmation Section for Return Trip Cancellation


            let response = await APICom.fetchData("", "TripActions/PerformNoShow", "post", { "Content-Type": "application/json" }, noShowObj, null);
            let result = response.data;
            if(result.rowcount > 0)
            {
                setNoShowAlert({...noShowAlert, alertTitle: 'No-Show', alertMsg:'Trip marked No-Show successfully.'});
                setDisplayNoShowAlert(true);
                return false;
            }
        }
    }

    const handleCancelDialogClose = () => {
        setNoShowDialog(false);
        UnMountNoShowComponent();
    }

    const handleAlertModalClose = () => {
        setDisplayNoShowAlert(false);
        UnMountNoShowComponent();
      }

    const UnMountNoShowComponent = () => {
        if(props.invokeNoShowComponent)
        {
            props.RefreshGridData();
            props.setInvokeNoShowComponent(false);
        }
    }

    const handleCancelReturnTripDialogYes = () => {
        try {
           
          confirmationPromptForReturnCanNSAlert?.onConfirm();
        } catch (error) {
          
        }
      }
    
      const handleCancelReturnTripDialogNo = () => {
        try {
           
          confirmationPromptForReturnCanNSAlert?.onCancel();
        } catch (error) {
          
        }
      }
    
      const handleCancelReturnTripDialogOK = () => {
        try {
           
          confirmationPromptForReturnCanNSAlert?.onOk();
        } catch (error) {
          
        }
      }

    return(
        <>
             {NoShowlDialog && 
             <Modal size="lg" centered show={NoShowlDialog} onHide={handleCancelDialogClose} onShow={OpenNoShowDialg} animation={false}>
                <Modal.Header  className='noshow_dialog_header_bgcolor mb-0' closeButton>
                <Modal.Title className='noshow_dialog_title_color'>No Show Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Container>
                    <Row>
                        <Col xs={6} md={3}>
                        <b>Conf#: </b>{noShowObj.iRefID}
                        </Col>
                        <Col xs={6} md={5}>
                        <b>Pickup Person: </b>{noShowObj.DisplayName}
                        </Col>
                        <Col xs={6} md={4}>
                        <b>{chkReturnTripVisible && <Form.Check type="checkbox" label="NoShow with return leg(s)" id="chkReturnTrips" checked={isReturnTripCheckBox} ref={chkReturnTripRef}  onChange={handleReturnTripCheckBox} className='noshow_dialog_returncheckbox_color' />}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} md={6}>
                        {showTripStatus && <Form.Label><b>Status:<span className='noshow_dialog_tripStatus_color'>&nbsp; is {noShowObj.TripRequestStatus}, Still want to No-Show?</span></b></Form.Label>}
                        </Col>
                        <Col xs={6} md={2}>
                            &nbsp;
                        </Col>
                        <Col xs={6} md={4}>
                            &nbsp;
                        </Col>
                    </Row>
                    </Container>
                    <Form>
                    
                        <Form.Group className="mb-2 noshow_dialog_reason_indent" controlId="exampleForm.ControlInput1">
                        <Form.Label><b>Reason</b></Form.Label>
                        <Form.Select aria-label="Default select example" onChange={handleCancelReasonChange} ref={noshowReasonRef} >
                            {noShowReasons.map(({ id, name }, index) => <option key={id} value={id} >{name}</option>)} 
                        </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-0 cancel_dialog_reason_indent" controlId="exampleForm.ControlTextarea1">
                        <Form.Label><b>Any Comments</b></Form.Label>
                        <Form.Control as="textarea" rows={2} ref={noshowCommentRef} />
                        <Form.Label><b>Internal Notes</b></Form.Label>
                        <Form.Control as="textarea" rows={2} ref={noshowInternalCommentRef} />
                        </Form.Group>
                    </Form>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelDialogClose}>
                        Cancel
                    </Button>
                    <Button className='noshow_btn_ok' onClick={handleNoShowDialogOK}>
                        Ok
                    </Button>
                    </Modal.Footer>
            </Modal> }
            { displayNoShowAlert && <Modal centered show={displayNoShowAlert} onHide={handleAlertModalClose} animation={false}>
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noShowAlert.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{noShowAlert.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>}
                {showConfirmationPromptForReturnCanNS && 
            <Modal size="sm" centered show={showConfirmationPromptForReturnCanNS}  keyboard={true} backdrop="static" animation={true}>
                <Modal.Header  className='cancel_dialog_header_bgcolor mb-0' closeButton>
                <Modal.Title className='cancel_dialog_title_color user-select-none'>Warning:</Modal.Title>
                </Modal.Header>
                <Modal.Body className='user-select-none'>
                <Container>
                <b>{confirmationPromptForReturnCanNSAlert.alertMsg}</b>
                </Container>
                </Modal.Body>
                {promptForReturnCanNS &&
                    <Modal.Footer>
                    <Button className='cancel_btn_ok' onClick={handleCancelReturnTripDialogYes}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={handleCancelReturnTripDialogNo}>
                        No
                    </Button>
                    </Modal.Footer>
                }
                {!promptForReturnCanNS && 
                    <Modal.Footer>
                    <Button className='cancel_btn_ok' onClick={handleCancelReturnTripDialogOK}>
                        Ok
                    </Button>
                </Modal.Footer>}
            </Modal>}
        </>
    );
}

export default NoShow;